/**
 * keys for Paste Option buttons
 */
export type PasteOptionButtonKeys =
    | 'pasteOptionPasteAsIs'
    | 'pasteOptionPasteText'
    | 'pasteOptionMergeFormat'
    | 'pasteOptionPasteAsImage';

/**
 * Localized string keys for Paste Option buttons and its UI component
 */
export type PasteOptionStringKeys = PasteOptionButtonKeys | 'pasteOptionPaneText';
